import { render, staticRenderFns } from "./TabDetails.vue?vue&type=template&id=c0b9bd0c"
import script from "./TabDetails.vue?vue&type=script&lang=js"
export * from "./TabDetails.vue?vue&type=script&lang=js"
import style0 from "./TabDetails.vue?vue&type=style&index=0&id=c0b9bd0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports